import { apiEndpoints } from '@/apiEndpoints';
import { CreateFlightWithTranslationsType } from '@/types/benefits/flight/CreateFlight.type';
import { FlightResponse } from '@/types/benefits/flight/FlightResponse';
import { SupportedLocale } from '@/types/supported-locale.type';
import axios from 'axios';

export const createFlight = async (data: CreateFlightWithTranslationsType) =>
  axios.post(apiEndpoints.flights.base, data);

export const updateFlight = async (
  benefitId: string,
  data: Partial<CreateFlightWithTranslationsType>,
  language?: SupportedLocale,
) =>
  axios.put(apiEndpoints.flights.detail(benefitId), data, {
    params: { language },
  });

export const getFlightCities = async (country?: string) => {
  const result = await axios.get<Array<{ city: string }>>(
    apiEndpoints.flights.cities,
    { params: { country } },
  );
  return result.data;
};

export const getFlightAirports = async (country?: string) => {
  const result = await axios.get<Array<{ airport: string }>>(
    apiEndpoints.flights.airports,
    {
      params: { country },
    },
  );
  return result.data;
};

export const getFlight = async (benefitId: string) => {
  const result = await axios.get<FlightResponse>(
    apiEndpoints.flights.detail(benefitId),
  );
  return result.data;
};

export const duplicateFlight = async (benefitId: string, fields: string[]) => {
  const result = await axios.post(apiEndpoints.flights.duplicate(benefitId), {
    fields,
  });
  return result.data;
};
